/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 */

import { Box, Button, Chip, DialogContent, Typography, styled } from "@mui/material";

export const MembersCard = styled(Box)({
  backgroundColor: "transparent",
  border: "1px solid #e0e0e0",
  borderRadius: "10px",
  padding: "16px",
});

export const MembersHeader = styled(Box)({
  alignItems: "flex-start",
  display: "flex",
  gap: "12px",
  justifyContent: "space-between",
  marginBottom: "12px",
  "@media (max-width: 720px)": {
    flexDirection: "column",
  },
});

export const MembersTitleRow = styled(Box)({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
});

export const MembersTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "16px",
  fontWeight: 600,
});

export const MembersCountPill = styled(Box)({
  alignItems: "center",
  backgroundColor: "#e8eefb",
  borderRadius: "999px",
  color: "#395bbd",
  display: "inline-flex",
  fontSize: "12px",
  fontWeight: 700,
  minHeight: "24px",
  padding: "0 10px",
});

export const MembersDescription = styled(Typography)({
  color: "#6b7280",
  fontSize: "13px",
  lineHeight: 1.5,
});

export const MembersActionButton = styled(Button)({
  "&:hover": {
    backgroundColor: "transparent",
    border: "2px solid #001b59",
    boxShadow: "none",
    color: "#001b59",
  },
  alignSelf: "flex-start",
  border: "2px solid #395bbd",
  borderRadius: "8px",
  boxShadow: "none",
  color: "#395bbd",
  minHeight: "40px",
  minWidth: "172px",
  paddingLeft: "16px",
  paddingRight: "16px",
  fontWeight: 600,
  textTransform: "none",
  whiteSpace: "nowrap",
  "@media (max-width: 720px)": {
    alignSelf: "stretch",
    width: "100%",
  },
});

export const MembersChipWrap = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
});

export const MemberChip = styled(Chip)({
  backgroundColor: "#ffffff",
  border: "1px solid #dbe3f0",
  borderRadius: "999px",
  color: "rgba(81, 81, 82, 1)",
  fontWeight: 500,
});

export const MembersEmptyState = styled(Typography)({
  color: "#6b7280",
  fontSize: "14px",
  fontStyle: "italic",
});

export const MembersDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  minHeight: "240px",
  padding: "20px 20px 0",
});

export const MembersSearchFieldWrap = styled(Box)({
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: "#fff",
});

export const MembersListState = styled(Box)({
  alignItems: "center",
  color: "#6b7280",
  display: "flex",
  flex: 1,
  fontSize: "14px",
  justifyContent: "center",
  minHeight: "160px",
  textAlign: "center",
});

export const MembersDialogActions = styled(Box)({
  borderTop: "1px solid #e5e7eb",
  display: "flex",
  gap: "12px",
  justifyContent: "flex-end",
  padding: "16px 20px",
  backgroundColor: "#ffffff",
});

export const MembersSelectionSummary = styled(Typography)({
  color: "#6b7280",
  fontSize: "13px",
});
